import * as Types from 'src/actions/investment/set-data/Types';
import { Action } from 'redux';
import { ActionCreator } from 'react-redux';
import Investment from 'src/entities/Investment';

export interface SetInvestmentData extends Action {
  type: Types.SET_INVESTMENT_DATA;
  payload: Investment;
}

export type SetInvestmentDataAction = SetInvestmentData;

export const setInvestmentData: ActionCreator<SetInvestmentData> = (investment: Investment) => (
  {
    type: Types.SET_INVESTMENT_DATA,
    payload: investment
  }
);


// WEBPACK FOOTER //
// ./src/actions/investment/set-data/SetInvestmentData.actions.tsx